export default "__VITE_ASSET__DrjzHKiZ__"